import { getCookie, setCookie } from './cookieHelpers';
import { LogHelpers } from './logHelper';

export class CookieSettings {
    necessary = true;
    functionalPerformance = false;
    analytics = false;
    marketingThirdParty = false;
    constructor(parameters?: Partial<CookieSettings>) {
        Object.assign(this, parameters);
    }

    load() {
        const data = JSON.parse(getCookie('cookie-settings'));
        if (data) {
            Object.assign(this, data);
        }
    }

    save() {
        const data = JSON.stringify(this);
        const logHelper = new LogHelpers('CookieSettings');
        logHelper.log(data);
        setCookie('cookie-settings', data, 180);
    }

    enableAll() {
        this.necessary = true;
        this.functionalPerformance = true;
        this.analytics = true;
        this.marketingThirdParty = true;
    }
}